import { RouterState } from '@ngrx/router-store';
import { StaticState, STATIC_STATE_INIT } from './static/index';
import { UIState, UI_STATE_INIT } from './ui/index';
import { MainState, MAIN_STATE_INIT } from './main/index';
import { UserState, USER_STATE_INIT } from './user/index';
import { ListState, LIST_STATE_INIT } from './list/index';


export interface AppState {
  router: RouterState;
  static: StaticState,
  ui: UIState;
  main: MainState;
  user: UserState;
  list: ListState;
}

export const APP_STATE_INIT: AppState = {
  router: { path: window.location.pathname + window.location.search },
  static: STATIC_STATE_INIT,
  ui: UI_STATE_INIT,
  main: MAIN_STATE_INIT,
  user: USER_STATE_INIT,
  list: LIST_STATE_INIT,
}



// WEBPACK FOOTER //
// ./src/app/store/app-state.ts